import { z } from 'zod';
import { ProductTypeSchema } from '../inputTypeSchemas/ProductTypeSchema'
import { DataSyncExternalRecordTypeSchema } from '../inputTypeSchemas/DataSyncExternalRecordTypeSchema'
import { DataSyncRecordTypeSchema } from '../inputTypeSchemas/DataSyncRecordTypeSchema'

/////////////////////////////////////////
// CORE INTEGRATION DATA SYNC RECORD SCHEMA
/////////////////////////////////////////

export const CoreIntegrationDataSyncRecordSchema = z.object({
  gogovRecordType: ProductTypeSchema,
  externalRecordType: DataSyncExternalRecordTypeSchema,
  dataSyncRecordType: DataSyncRecordTypeSchema,
  id: z.number().int(),
  cityId: z.number().int(),
  integrationId: z.number().int(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  lastPushedAt: z.coerce.date().nullable(),
  lastPulledAt: z.coerce.date().nullable(),
  lastPushError: z.string().nullable(),
  lastPullError: z.string().nullable(),
  gogovRecordId: z.bigint(),
  gogovRecordUpdatedAt: z.coerce.date().nullable(),
  gogovToExternalHash: z.string().nullable(),
  externalRecordId: z.string().nullable(),
  externalRecordUpdatedAt: z.coerce.date().nullable(),
  externalToGogovHash: z.string().nullable(),
  externalRecordUrl: z.string().nullable(),
  parentDataSyncRecordId: z.number().int().nullable(),
  deSyncedAt: z.coerce.date().nullable(),
  externalDisplayId: z.string().nullable(),
  dynamicExternalRecordType: z.string(),
  gogovRecordDisabledAt: z.coerce.date().nullable(),
})

export type CoreIntegrationDataSyncRecord = z.infer<typeof CoreIntegrationDataSyncRecordSchema>

export default CoreIntegrationDataSyncRecordSchema;
